import React from "react";

import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import {
  PREFERENCES_TABLE_HEADER,
  ROLE_PREFERENCES_FEATURES,
  ROLE_PREFERENCES_FIELD,
  ROLE_PREFERENCES_FIELD_DESCRIPTION,
  USER_ROLES,
} from "static/preferences";

import EditRolePreference from "components/pages/accountPreferences/list/table/EditRolePreference";
import { sortByReferenceArray } from "utils/accountPreference";

const AccountPreferenceTable = ({
  changeRole,
  isEditPreference,
  preference,
}) => {
  return (
    <div className="preferences-table">
      <Table>
        <TableHead>
          <TableRow>
            {PREFERENCES_TABLE_HEADER.map((header, index) => (
              <TableCell key={index}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(preference).map(([featureKey, featureValue]) => (
            <>
              <TableRow className="column-header">
                <TableCell colSpan={3}>
                  {ROLE_PREFERENCES_FEATURES[featureKey]}
                </TableCell>
              </TableRow>
              {Object.entries(featureValue).map(
                ([fieldKey, fieldValue], fieldIndex) => {
                  const sortedFeatureRoles = sortByReferenceArray(
                    fieldValue,
                    USER_ROLES
                  );

                  return (
                    <TableRow key={fieldIndex}>
                      <TableCell>{ROLE_PREFERENCES_FIELD[fieldKey]}</TableCell>
                      <TableCell>
                        {ROLE_PREFERENCES_FIELD_DESCRIPTION[fieldKey]}
                      </TableCell>
                      <TableCell className="preferences-roles">
                        {isEditPreference ? (
                          <EditRolePreference
                            featureKey={featureKey}
                            fieldKey={fieldKey}
                            roles={fieldValue}
                            changeRole={changeRole}
                          />
                        ) : (
                          sortedFeatureRoles?.map((role, index) => (
                            <Chip key={index} label={role} />
                          ))
                        )}
                      </TableCell>
                    </TableRow>
                  );
                }
              )}
            </>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default AccountPreferenceTable;
